<p>template-row-view-var works!</p>
